(function () {
    'use strict';

    angular
        .module('invesfleet')
        .directive('filterSection', filterSection);

    filterSection.$inject = ['$timeout'];

    function filterSection($timeout) {
        
        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/views/directives/filterSection.html',
            scope: {
                fields: '=',
                applyFilter: '&',
                saveFilter: '&',
                onChange: '&',
                parent: '=',
                control: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            
            scope.filters = [];
            var lastFilters = null;

            function getFilterFromField(field){
                var filter = {
                    input1 : null,
                    input2 : null,
                    dataRef : field.data,
                    data : [],
                    display: field.display, 
                    type: field.type,
                    field: field.field,
                    getData: field.getData,
                    params: field.params,
					default: field.default,
					onChange: field.onChange
                };

                if(filter.dataRef){
                    filter.data = scope.parent[field.data];
                }
                if(filter.getData){
                    filter.isLoading = true;
                    scope.parent[filter.getData](filter.params).then(function(data){ 
						filter.data = data;
						scope.parent[field.data] = filter.data;
                        filter.isLoading = false;
                    });
                }

                return filter;
            }

            angular.forEach(scope.fields, function(value, key) {
                if(value.default){
                    scope.filters.push(getFilterFromField(value));
                }
            });

			scope.filterChanged = function (filter) {
                scope.onChange();
            };

            scope.newFilter = function() {
                if (!scope.selectedField) { return; }
                var f = getFilterFromField(scope.selectedField);
                f.default = false;
                scope.filters.push(f);
                scope.selectedField = null;
            };
            
            /**
             * Execute filters
             */
            scope.doFilter = function(skipSave) {
                var appliedFilters = [];

                angular.forEach(scope.filters, function(filter, key) {
                    switch(filter.type){
                        case 'multi':
                            if(filter.input1.length > 0){
                                appliedFilters.push(createReturnFilter(filter));
                            }
                            break;
                        case 'date':
							if (filter.date.selected && filter.input1 !== null &&
								filter.input2 !== null && filter.input1 !== undefined &&
								filter.input2 !== undefined) {
                                appliedFilters.push(createReturnFilter(filter,1));
                                appliedFilters.push(createReturnFilter(filter,2));
                            }
                            break;
                        default:
                            if(filter.input1 !== null && filter.input1 !== ''){
                                appliedFilters.push(createReturnFilter(filter));
                            }
                            break;
                    }
                });

                if(!skipSave) {lastFilters = scope.getFilters();}
                scope.applyFilter({filters: appliedFilters});
            };

            function createReturnFilter(filter, take){
                /* jshint maxcomplexity:false */ 
                var op = null;
                var input = [];

                if (filter.type === 'string' || filter.type === 'number') {
                    op = filter.operator.id;
                    input.push(filter.input1);
                }
                else if(filter.type === 'date'){
                    if(take === 1){
                        op = '>=';
                        if(typeof filter.input1 === 'string'){
                            input.push(filter.input1);
                        }else{
                            input.push(filter.input1);
                        }
                    } else {
                        op = '<=';
                        if(typeof filter.input2 === 'string'){
                            input.push(filter.input2);
                        }else{
                            input.push(filter.input2);
                        }
                    }
                }
                else if (filter.type === 'options') { 
                    op = '=';
                    angular.forEach(filter.input1, function(value, key) {
                        input.push(value.id);
                    });
                }
                else if(filter.type === 'multi'){ 
                    op = 'IN'; 
                    angular.forEach(filter.input1, function(value, key) {
                        input.push(value.id);
                    });
                }

                var type = typeof input[0];

                return {
                    field: filter.field,
                    opt: op,
                    input: input,
                    type: type
                };
            }

            scope.getFilters = function(){
                /*jshint maxcomplexity:false */
                var fs = [];
                angular.forEach(scope.filters, function (value, key) {

                    var f = {};
                    f.field = value.field;
                    f.type = value.type;
                    f.display = value.display;
                    f.getData = value.getData;
                    f.params = value.params;
                    f.dataRef = value.dataRef;
                    f.default = value.default;

                    if (value.type === 'date') {
                        f.id = value.date.selected? value.date.selected.id : null;
                        if(f.id === 'custom'){
                            f.input1 = value.input1;
                            f.input2 = value.input2;
                        }
                    } 
                    if(value.type === 'number' || value.type === 'string'){
                        f.operator = value.operator? value.operator.id : null;
                        f.input1 = value.input1; 
                    }
                    if(value.type === 'select'){
                        f.input1 = value.input1? value.input1.id : null;
                    }
                    if(value.type === 'multi'){
                        f.input1 = value.input1.map(function (v){ return v.id; });
                        //f.input1 = value.input1.map(function (v){ return Object.assign({},v.id); });
                    }
                    fs.push(Object.assign({},f));
                });
                return fs;
            };

            /**
             * Save actual filters as predefined
             */
            scope.save = function(){
                if(!scope.filterName){ return; }
                
                var fs = scope.getFilters();

                scope.saveFilter({name: scope.filterName, filters: fs});
                scope.filterName = '';
            };

            scope.setPredefinedFilters = function(filtros){
                /*jshint maxcomplexity:false */
                scope.filters = [];

                angular.forEach(filtros, function (value, key) {
                    var f = {};
                    f.field = value.field;
                    f.type = value.type;
                    f.display = value.display;
                    f.getData = value.getData;
                    f.params = value.params;
                    f.dataRef = value.dataRef;
                    f.default = value.default;

                    f.data = scope.parent[value.dataRef];
                    if(value.getData){
                        scope.parent[value.getData](value.params).then(function(data){ 
                            f.data = data; 
                        });
                    }
					if (value.type === 'date') {
						
                        f.date = { selected: { id: value.id } };
                        if(f.date.selected.id === 'custom'){
                            f.input1 = value.input1 && new Date(value.input1);
                            f.input2 = value.input2 && new Date(value.input2);
						}
						else if (f.date.selected.id === 'hoy') {
							var today = Date.NewDate();
							f.input1 = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);
							f.input2 = new Date(today.getFullYear(),
								today.getMonth(),
								today.getDate() + 1,
								0, 0, 0);           
						}
						else if (f.date.selected.id === null) {
                            f.input1 = null;
                            f.input2 = null;
                        }
                    }
                    if(value.type === 'number' || value.type === 'string'){
                        f.operator = { id: value.operator };
                        f.input1 = value.input1; 
                    }
                    if(value.type === 'select'){
                        f.input1 = { id: value.input1 };
                    }
                    if(value.type === 'multi'){
                        f.input1 = value.input1.map(function (v){ return { id: v}; });
                    }

                    scope.filters.push(f);
                });

                $timeout(function () {
                    $timeout(function () {
                        $timeout(function () {
                    scope.doFilter();
                        });
                    });
                });
            };

            scope.clearAllFilters = function(skipDoFilter){
                angular.forEach(scope.filters, function (value, key) {
                    if(value.type === 'multi'){
                        value.input1 = [];
                    }else{
                        value.input1 = null;
                    }
                    value.input2 = null;
                   // value.operator = null;
                    if(value.date){
                        value.date.selected = null;
                    }
                });
                scope.filters = scope.filters.filter(function (item) {
                    return item.default === true;
                });
                if(!skipDoFilter) {scope.doFilter();}
            };

            scope.clearModifiedFilters = function(){
                scope.clearAllFilters(true);
                if(lastFilters !== null){ scope.setPredefinedFilters(lastFilters); }
            };

            //To expose methos for the controller to call
            scope.internalControl = scope.control || {};
            scope.internalControl.applyFilter = scope.doFilter;
            scope.internalControl.setPredefinedFilters = scope.setPredefinedFilters;
            scope.internalControl.clearFilters = scope.clearAllFilters;
            scope.internalControl.getFilters = scope.getFilters;
            scope.internalControl.clearModifiedFilters = scope.clearModifiedFilters;
        }
    }
})();